import mapKeys from "lodash/mapKeys";

//const serverUrl = "http://localhost:8081";
const serverUrl = "https://api.rangedrill.com";

export function getHandTypes(board, combos) {
  const data = { board, combos };
  return fetch(`${serverUrl}/handtypes`, {
    method: "POST",
    mode: "cors",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then(res => res.json())
    .then(json => mapKeys(json, (value, key) => key.split(",").join("")));
  //.then(data => console.log(data) || data);
}
